import { loadScript } from '@paypal/paypal-js'
import type { PayPalNamespace } from '@paypal/paypal-js'

// We are using globals to prevent the paypal script from loading twice if this
// module is used in different entrypoints.
declare global {
  interface Window {
    paypalPayLaterLoading: boolean
    paypalPayLaterUnitialized: Array<HTMLElement>
  }
}
window.paypal = window.paypal || null
window.paypalPayLaterLoading = window.paypalPayLaterLoading || false
window.paypalPayLaterUnitialized = window.paypalPayLaterUnitialized || []

export default async (element: HTMLElement): Promise<void> => {
  // Load the paypal SDK if it's not yet loaded, then trigger the message creation on the given element.
  if (window.paypal === null) {
    window.paypalPayLaterUnitialized.push(element)
    if (window.paypalPayLaterLoading === false) {
      window.paypalPayLaterLoading = true
      // There should be a single value for all data-cpp-client-identifier in
      // a single page. Thus the first is used to instantiate the PayPal SDK.
      const clientIdentifier = element.getAttribute('data-cpp-client-identifier') ?? ''

      const paypal = await loadScript({
        clientId: clientIdentifier,
        currency: 'EUR',
        components: ['messages'],
      })
      if (paypal !== null) {
        for (const element of window.paypalPayLaterUnitialized) {
          await paypal.Messages?.().render(element)
        }
      }
    }

    return
  }

  await (window.paypal as PayPalNamespace).Messages?.().render(element)
}
